import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";
import { FieldInputProps } from "react-final-form";

import { DesignToken, Icon, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { TriggerFieldArrayElement } from "../../interfaces";

import { TriggerLabel } from "./TriggerLabel";
import { TRIGGER_ICON, mapTriggerToTriggerType } from "./utils";

interface IProps {
  input: FieldInputProps<TriggerFieldArrayElement>;
}

export const TriggerAccordionLabel: FC<IProps> = ({ input }) => {
  const triggerType = mapTriggerToTriggerType(input.value);

  if (!triggerType) {
    return null;
  }

  return (
    <Container>
      <TriggerIcon source={TRIGGER_ICON[triggerType]} customColor={withVar(DesignToken.ContentBasicSecondary)} />
      <LabelContainer>
        <TriggerLabel input={input} />
      </LabelContainer>
    </Container>
  );
};

const TriggerIcon = styled(Icon)`
  margin-right: ${withVar(SpacingToken.Spacing1)};
  margin-top: ${withVar(SpacingToken.Spacing05)};
  align-self: flex-start;
`;

const containerStyles = css`
  display: flex;
  gap: ${withVar(SpacingToken.Spacing1)};
`;

const Container = styled.div`
  ${containerStyles}
`;

const LabelContainer = styled(Container)`
  ${containerStyles}
  flex-wrap: wrap;
  align-items: center;
`;
